import { Button } from "@/components/button";
import { useImpersonate } from "@/hooks/useImpersonate";

export function ImpersonateButton({
  currentProjectId,
  id,
  isDisabled,
}: {
  currentProjectId?: null | number;
  id: string;
  isDisabled: boolean;
}) {
  const impersonateMutation = useImpersonate();

  return (
    <Button
      className="w-full"
      isDisabled={isDisabled || impersonateMutation.isPending}
      onPress={() =>
        impersonateMutation.mutate({
          targetUserCurrentProjectId: currentProjectId,
          targetUserId: Number(id),
        })
      }
      variant="secondary"
    >
      Impersonate
    </Button>
  );
}
